export default {
  TITLE: "Products sold (POS)",
  SUBTITLE: "Sales from ISTHERA cash registers",

  // Filters
  ESTABLISHMENTS: "Establishments",
  SERVICE_CENTER: "Service center",
  CAFETERIA: "Cafeteria",
  CAISSES: "Cash registers",
  DEPARTMENT_CODE: "Department (code)",
  SEARCH: "Search (item or description)",
  GROUP_BY: "Group by",
  AVAILABLE_DATA: "Available data",

  // Axes / dimensions
  DIMENSION_ESTABLISHMENT: "Establishment",
  DIMENSION_SERVICE_CENTER: "Service center",
  DIMENSION_CAFETERIA: "Cafeteria",
  DIMENSION_CAISSE: "Cash register",
  DIMENSION_PRODUCT: "Product",
  DIMENSION_DEPARTMENT: "Department",
  DIMENSION_DAY: "Day",
  DIMENSION_WEEK: "Week",
  DIMENSION_MONTH: "Month",
  DIMENSION_CASHIER: "Cashier",

  // Columns
  ESTABLISHMENT: "Establishment",
  CAISSE: "Cash register",
  ARTICLE: "Item",
  DESCRIPTION: "Description",
  DEPARTMENT: "Department",
  PERIOD: "Period",
  CASHIER: "Cashier",
  QUANTITY: "Quantity",
  COST: "Cost",
  NET_SALES: "Net sales",
  DISCOUNT: "Discount",

  // Stats
  TOTAL_GROUPS: "Rows",
  TOTAL_QUANTITY: "Total quantity",
  TOTAL_NET_SALES: "Total net sales",
  TOTAL_DISCOUNT: "Total discount",
  TOTAL_COST: "Total cost",

  // Misc
  TOTAL: "Total",
  NO_DATA: "No data for these filters",
  COST_UNAVAILABLE: "Cost is not captured in ISTHERA (shown as 0).",
};
